module.exports = __webpack_public_path__ + "static/img/case-dd-page-bg-02.2fad140.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/dd/case-dd-page-bg-02.jpg
// module id = C2wG
// module chunks = 1